import { ComponentMessageTheme, variants } from '../ComponentMessageStyles.css';
import { baseTheme } from './ComponentMessageBaseTheme.css';
import { multiVariantStyles } from './ComponentMessageVariants.css';

/*******************
 * Component Theme
 *******************/

const ComponentMessageStableTheme: ComponentMessageTheme = {
  baseTheme,
  multiVariantStyles,
  variants
};

/*******************
 * Exports
 *******************/

export { ComponentMessageStableTheme };
